// extracted by mini-css-extract-plugin
export var displayNone = "_ui-6";
export var imgContainer = "_ui-2";
export var overflowHidden = "_ui-3";
export var productInfoCardButtonContainer = "_ui-5";
export var productTitleText = "_ui-4";
export var rightArrow = "_ui-1";
export var rightArrowContainer = "_ui-0";